import axios from 'axios'
import { Component } from 'preact'
import ButtonControl from '../button-control'

interface Props {
  showDeleteButton: boolean
  showSendButton: boolean
  email: string
  error: string | null
  onChange: (val: string) => void
  onDelete: () => void
}

interface State {
  email: string
  sendLoading: boolean
  deleteLoading: boolean
  error: string | null
}

interface WebmasterCandidateComponentProps extends Props, State {
  onChange: (val: string) => void
  deleteEmail: () => void
  sendVerificationEmail: () => void
}

class WebmasterCandidate extends Component<Props, State> {
  constructor (props: Props) {
    super()
    this.state = {
      email: props.email,
      sendLoading: false,
      deleteLoading: false,
      error: null
    }
  }

  async sendEmail () {
    if (this.state.email) {
      this.setState({ sendLoading: true })
      try {
        await axios.post('/settings/emailManagement/sendVerificationMail', {
          email: this.state.email
        })
        this.setState({ sendLoading: false }, () => {
          window.location.reload()
        })
      } catch (e) {
        this.setState({ sendLoading: false, error: e.response ? e.response.data.error : 'Something went wrong. Please, refresh the page and try again.' })
      }
    }
  }

  async deleteEmail () {
    this.setState({ deleteLoading: true })
    try {
      await axios.post('/settings/emailManagement/deleteCandidate', {
        email: this.props.email
      })
      this.setState({ deleteLoading: false })
      this.props.onDelete()
    } catch (e) {
      this.setState({
        deleteLoading: false,
        error: 'Something went wrong. Please, refresh the page and try again.'
      })
    }
  }

  render (props: Props, state: State) {
    return (
      <WebmasterCandidateComponent
        {...state}
        {...props}
        email={props.email || state.email}
        onChange={(val: string) => this.setState({ email: val })}
        sendVerificationEmail={async () => await this.sendEmail()}
        deleteEmail={async () => await this.deleteEmail()}
      />
    )
  }
}

const WebmasterCandidateComponent = (props: WebmasterCandidateComponentProps) => <div class='item row'>
  {props.error ? <div class='alert alert-danger'>{props.error}</div> : null}
  <input
    id='email'
    class='js-email'
    type='email'
    placeholder='info@example.com'
    value={props.email}
    onChange={(event) => props.onChange((event.target as HTMLInputElement).value)}
  />
  {props.showSendButton ? <ButtonControl variant='success' title='Send verification mail' isLoading={props.sendLoading} onClick={props.sendVerificationEmail} /> : null}
  {props.showDeleteButton ? <ButtonControl variant='danger' title='Delete email-address' isLoading={props.deleteLoading} onClick={props.deleteEmail} /> : null}
</div>

export { WebmasterCandidateComponent }
export default WebmasterCandidate
